import React from 'react';
import { motion } from 'framer-motion';
import { Layers, CheckCircle2, ArrowUpRight } from 'lucide-react';
import { products } from '../mock';

const Products = () => {
  return (
    <section id="products" className="py-24 relative overflow-hidden bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Title */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-xs font-bold tracking-widest uppercase text-pink-600 mb-3"
          >
            Ready Software Solutions
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-5xl font-extrabold font-display text-slate-900 tracking-tight"
          >
            Enterprise Software Products
          </motion.p>
        </div>

        {/* Products Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              whileHover={{ y: -8 }}
              className="p-8 rounded-3xl glass-card flex flex-col justify-between group relative overflow-hidden"
            >
              {/* Category Pill */}
              <div className="flex items-center justify-between mb-6">
                <span className="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-100 text-pink-700 border border-pink-200">
                  {product.category}
                </span>
                <Layers size={20} className="text-slate-400 group-hover:text-pink-600 transition-colors" />
              </div>

              <div>
                <h3 className="text-2xl font-bold font-display text-slate-900 mb-3 group-hover:text-pink-600 transition-colors">
                  {product.name}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-6 font-normal">
                  {product.description}
                </p>

                {/* Features */}
                <ul className="space-y-2.5 mb-8">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-xs text-slate-700 font-medium">
                      <CheckCircle2 size={14} className="text-pink-600 mr-2.5 shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <a
                href="#contact"
                className="w-full py-3 rounded-xl bg-slate-100 hover:bg-pink-600 hover:text-white transition-all duration-300 font-bold text-xs text-slate-800 flex items-center justify-center space-x-1 shadow-sm"
              >
                <span>Request Live Demo</span>
                <ArrowUpRight size={16} />
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
